import { useEffect, useRef } from 'react'
import DataTable from 'datatables.net'

interface Column {
  data: string
  title: string
  orderable?: boolean
  searchable?: boolean
  render?: (data: any, type: string, row: any) => string
  className?: string
}

interface ServerDataTableProps {
  ajaxUrl: string
  columns: Column[]
  order?: [number, 'asc' | 'desc'][]
  pageLength?: number
  className?: string
}

export default function ServerDataTable({
  ajaxUrl,
  columns,
  order = [[0, 'asc']],
  pageLength = 25,
  className = '',
}: ServerDataTableProps) {
  const tableRef = useRef<HTMLTableElement>(null)
  const dtRef = useRef<any>(null)

  useEffect(() => {
    if (!tableRef.current) return

    dtRef.current = new DataTable(tableRef.current, {
      serverSide: true,
      processing: true,
      ajax: ajaxUrl,
      columns,
      order,
      pageLength,
      dom: 'lfrtip',
      language: {
        processing: '<span class="text-accent">Loading...</span>',
        emptyTable: 'No data available',
        info: 'Showing _START_ to _END_ of _TOTAL_',
      },
    })

    return () => {
      dtRef.current?.destroy()
    }
  }, [ajaxUrl, columns, order, pageLength])

  return (
    <div className={className}>
      <table ref={tableRef} className="w-full" />
    </div>
  )
}
